import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { confirmUserOauth, createTransfer } from '../../firebase/api/stripe';
import { getUserPendingPayments, updateUser } from '../../firebase/api/users';
import { PROFILE } from '../../constants/routes';
import { Loader } from '../../components/elements/loader/Loader';
import './styles.css';

const StripeSuccessRedirect = () => {
    const history = useHistory();

    useEffect(() => {
        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');
        const userId = url.searchParams.get('state');
        let currentUserStripeUserId = null;

        if (code && userId) {
            confirmUserOauth(code)
                .then(({ data: { stripe_user_id: stripeUserId } }) => {
                    currentUserStripeUserId = stripeUserId;
                    return updateUser({ uid: userId, stripeUserId });
                })
                .then(() => getUserPendingPayments(userId))
                .then(pendingPayments => {
                    if (!pendingPayments.length) {
                        return Promise.resolve();
                    }

                    return Promise.all(
                        pendingPayments.map(pp => {
                            const amount = pp.amount - pp.feeAmount;

                            return createTransfer({
                                destination: currentUserStripeUserId,
                                transferGroup: pp.transferGroup,
                                userId,
                                amount,
                            });
                        })
                    );
                })
                .then(() => {
                    history.push(PROFILE);
                });
        }
    }, [history]);

    return (
        <div className="stripe-redirect__container">
            <Loader />
        </div>
    );
};

StripeSuccessRedirect.propTypes = {};

export default React.memo(StripeSuccessRedirect);
